module.exports = __webpack_public_path__ + "img/smart1.28c1e3c8.png";